import { render } from "./mvt-nearbyafford.vue?vue&type=template&id=0bf46dfb"
import script from "./mvt-nearbyafford.js?vue&type=script&lang=js"
export * from "./mvt-nearbyafford.js?vue&type=script&lang=js"

import "./mvt-nearbyafford.vue?vue&type=style&index=0&id=0bf46dfb&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__